import { render, staticRenderFns } from "./dmEditRecord.vue?vue&type=template&id=f6a15cd8"
import script from "./dmEditRecord.ts?vue&type=script&lang=js&external"
export * from "./dmEditRecord.ts?vue&type=script&lang=js&external"
import style0 from "./dmEditRecord.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports